module.exports = __webpack_public_path__ + "static/media/qr_scanner_p1_1.f318a91f.png";